// extracted by mini-css-extract-plugin
export default {"collapsibleInsuranceMinimums":"style_collapsibleInsuranceMinimums__E81ku"};